import { useState, useEffect, useRef } from "react";
import { FiX, FiSearch } from "react-icons/fi";
import BOOTSTRAP_ICONS from "../../data/bootstrap-icons";

const IconPickerModal = ({ show, currentIcon, onSelect, onClose }) => {
  const [search, setSearch] = useState("");
  const searchRef = useRef(null);

  const filtered = search.trim()
    ? BOOTSTRAP_ICONS.filter(name => name.includes(search.trim().toLowerCase()))
    : BOOTSTRAP_ICONS;

  // Reset search and focus input when modal opens
  useEffect(() => {
    if (show) {
      setSearch("");
      setTimeout(() => searchRef.current?.focus(), 80);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{ zIndex: 11000 }}
    >
      <div
        className="icon-picker-modal"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="modal-header">
          <h4 style={{ margin: 0, fontSize: "16px", color: "#e5e7eb" }}>Choose an Icon</h4>
          <button className="modal-close" onClick={onClose}>
            <FiX />
          </button>
        </div>

        {/* Search */}
        <div style={{ padding: "12px 16px", borderBottom: "1px solid #374151" }}>
          <div style={{ position: "relative" }}>
            <FiSearch style={{
              position: "absolute", left: "12px", top: "50%",
              transform: "translateY(-50%)", color: "#6b7280", pointerEvents: "none"
            }} />
            <input
              ref={searchRef}
              type="text"
              className="icon-picker-search"
              placeholder="Search icons..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ paddingLeft: "36px" }}
            />
          </div>
        </div>

        {/* Current icon preview */}
        {currentIcon && (
          <div style={{
            padding: "10px 16px", borderBottom: "1px solid #374151",
            display: "flex", alignItems: "center", gap: "10px"
          }}>
            <span style={{ fontSize: "11px", color: "#6b7280" }}>Current:</span>
            <div style={{
              display: "flex", alignItems: "center", gap: "8px",
              background: "#1e1b4b", border: "2px solid #7c3aed",
              borderRadius: "8px", padding: "6px 10px"
            }}>
              <i className={`bi bi-${currentIcon}`} style={{ fontSize: "1.1rem", color: "#e5e7eb" }} />
              <span style={{ fontSize: "12px", color: "#a78bfa" }}>{currentIcon}</span>
            </div>
          </div>
        )}

        {/* Icon grid */}
        <div className="icon-grid">
          {filtered.slice(0, 400).map(name => (
            <div
              key={name}
              className={`icon-grid-item${name === currentIcon ? " selected" : ""}`}
              onClick={() => onSelect(name)}
              title={name}
            >
              <i className={`bi bi-${name}`} />
              <span>{name}</span>
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{
              gridColumn: "1 / -1", textAlign: "center",
              padding: "40px 0", color: "#6b7280", fontSize: "13px"
            }}>
              No icons found for "{search}"
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="icon-picker-footer">
          Showing {Math.min(filtered.length, 400)} of {filtered.length} matching icons
        </div>
      </div>
    </div>
  );
};

export default IconPickerModal;
